//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is
the property of 6over6 Ltd. and its licensors. Any use of the Software is
strictly prohibited unless an explicit license or permission is granted by
6over6 Ltd.
<template>
  <svg
    width="80"
    height="70"
    viewBox="0 0 80 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0435 27.0164C11.0435 24.1539 11.0459 22.1147 11.269 20.5664C11.4869 19.0544 11.8973 18.1575 12.6117 17.4909C13.336 16.8151 14.3263 16.4198 15.981 16.2122C17.6578 16.0019 19.8604 16 22.9224 16H55.1199C58.182 16 60.3845 16.0019 62.0613 16.2122C63.7161 16.4198 64.7063 16.8151 65.4306 17.4909C66.1451 18.1575 66.5555 19.0544 66.7734 20.5664C66.9965 22.1147 66.9989 24.1539 66.9989 27.0164V53.0534H11.0435V27.0164Z"
      :style="{ stroke: store.state.Style.themeColor }"
      stroke-width="2"
    />
    <path
      d="M8.44601 53.0533C7.57848 53.0533 6.75355 53.3119 6.12201 53.7787C5.49072 54.2454 5 54.9705 5 55.8614C5 57.2516 5.7645 58.4286 6.83843 59.2225C7.91261 60.0165 9.34904 60.4774 10.892 60.4774H67.1502C68.6932 60.4774 70.1297 60.0165 71.2038 59.2225C72.2778 58.4286 73.0423 57.2516 73.0423 55.8614C73.0423 54.9705 72.5516 54.2454 71.9203 53.7787C71.2887 53.3119 70.4638 53.0533 69.5963 53.0533H8.44601Z"
      :style="{ stroke: store.state.Style.themeColor }"
      stroke-width="2"
    />
  </svg>
</template>

<script setup>
import { useStore } from "vuex";
const store = useStore();
</script>
